import useBillingBalance from 'modules/queries/billing/useBalance';

const useExpectedBalance = (paymentAmount: string | number) => {
	const { data: billingBalanceData, ...restBillingBalance } =
		useBillingBalance();
	const { accountBalanceDisplay } = billingBalanceData || {};

	const expectedRemainingBalanceRaw =
		Number(accountBalanceDisplay) - Number(paymentAmount);
	const expectedCredit =
		expectedRemainingBalanceRaw < 0 ? Math.abs(expectedRemainingBalanceRaw) : 0;
	const expectedRemainingBalance =
		expectedRemainingBalanceRaw < 0 ? 0 : expectedRemainingBalanceRaw;
	const hasExpectedCredit = expectedCredit > 0;

	return {
		accountBalanceDisplay,
		expectedCredit,
		expectedRemainingBalance,
		hasExpectedCredit,
		...restBillingBalance,
	};
};

export default useExpectedBalance;
